import { render, staticRenderFns } from "./ExternalPrenotazioniListComponent.vue?vue&type=template&id=d447bd62"
import script from "./ExternalPrenotazioniListComponent.vue?vue&type=script&lang=js"
export * from "./ExternalPrenotazioniListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports